import variables from "@client.scss.variables";

export const allColors = {
  ...variables,
};

const useAvailableColors = () => {
  const colors = [
    variables.chartColor1,
    variables.chartColor2,
    variables.chartColor3,
    variables.chartColor4,
    variables.chartColor5,
  ];

  const getRandomColor = (colorArray = colors) => {
    const randomIndex = Math.floor(Math.random() * colorArray.length);
    return colorArray[randomIndex];
  };

  const getSubsequentColor = (index) => {
    return colors[index % colors.length];
  };

  return [getSubsequentColor, getRandomColor];
};

export default useAvailableColors;
